

import { mapActions } from 'vuex'
import utils from '@/components/tools/utils'

export default {

  props: {
    notifications: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      dialog: false,
      step: 1
    }
  },

  computed: {
    dialogWidth: {
      get () {
        if (this.$vuetify.breakpoint.mobile) {
          return '100%'
        } else {
          return '60%'
        }
      },
      set (value) {
      }
    },
    isLastStep () {
      return this.notifications?.length === this.step
    }
  },

  mounted () {
    this.dialog = this.notifications.length > 0
  },

  methods: {
    ...mapActions('customer', ['getCustomer']),
    async accept () {
      this.dialog = false
      await this.$axios.post('/private/customer/accept-tac', {})
      await this.getCustomer()
    },
    formatDate (value) {
      return utils.formatDateWithoutTime(value)
    },
    goNextOrClose () {
      if (this.isLastStep) {
        this.notifications.forEach(async (notification) => {
          await this.$axios.put('/private/merchant/mark-popup-as-read/' + notification.id, {})
        })

        this.dialog = false
      } else {
        this.step++
      }
    }
  }

}
